export default "/_next/static/images/8d/group@2x-8d74c06854ca7c780faad3219c35541f.jpg";